"use client";
import { styled } from "@mui/material/styles";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { DEFAULT_HEADER_TILE_BACKGROUND_COLOR, DEFAULT_FEATURE_TILE_TEXT_COLOR } from "./constants.js";
const MainContainer = styled(CostcoBox, {
  shouldForwardProp: (prop) => prop !== "isCardAsLink"
})(({ isCardAsLink }) => ({
  "&:hover": {
    textDecoration: "none",
    cursor: isCardAsLink ? "pointer" : "default"
  },
  borderRadius: "10px"
}));
const StyledLeftTile = styled(CostcoBox)`
    width: 50%;
    flex-grow: 1;
    background: ${(props) => props.background || DEFAULT_HEADER_TILE_BACKGROUND_COLOR};
    display: flex;
    flex-direction: column;
    @media (max-width: 768px) {
        width: 100%;
    }
`;
const LeftTileContent = styled(CostcoBox)`
    display: flex;
    flex-grow: 2;
    flex-direction: column;
    justify-content: center;
`;
const StyledRightTile = styled(CostcoBox)`
    display: flex;
    flex-direction: column;
    padding: 16px;
    flex: 50%;
    justify-content: center;
    background: ${(props) => props.background || DEFAULT_FEATURE_TILE_TEXT_COLOR};
    color: #333;
`;
const IconList = styled("ul")`
    margin: 0;
    padding: 0;
`;
export {
  IconList,
  LeftTileContent,
  MainContainer,
  StyledLeftTile,
  StyledRightTile
};
